import { queryOptions } from '@tanstack/react-query';
import getConfig from 'next/config';

import { donedealServicesGateway } from '../../../api/api-utils/commonApiUtils';
import { showroomFiltersSchema } from './showroomFilters.schema';

export const showroomFilters = (section: string, dealerSeoName: string) => {
  const {
    publicRuntimeConfig: { API_LISTINGS_TIMEOUT },
  } = getConfig();

  return queryOptions({
    queryKey: ['getDealershipFilters', section, dealerSeoName],
    queryFn: getShowroomFilters(section, dealerSeoName, API_LISTINGS_TIMEOUT),
    staleTime: Infinity,
  });
};

const getShowroomFilters =
  (section: string, dealerSeoName: string, timeout: number) => async () => {
    const response = await donedealServicesGateway.get(
      `/ddapi/v1/search/showroom/filters/${section}`,
      {
        params: { dealerSeoName },
        timeout: timeout,
      },
    );

    return showroomFiltersSchema.parse(response.data);
  };
